import React from "react";
import { createRoot } from "react-dom/client";
import { initI18nFromSSR } from "./i18n/initFromSSR";
import CartIndex from "./features/cart/CartIndex";

//init dayjs
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { CartSettings, validateCartSettings } from "./types/CartSettings";

dayjs.extend(utc);
dayjs.extend(timezone);

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const root = document.getElementById("cart-app");
  if (root) {
    // Get cart settings from data attribute
    const cartSettingsData = root.getAttribute("data-cart-settings");
    let cartSettings: CartSettings | null = null;
    if (cartSettingsData) {
      try {
        const rawSettings = JSON.parse(cartSettingsData);
        cartSettings = validateCartSettings(rawSettings);
        console.log("[cart.tsx] Validated settings:", cartSettings);
      } catch (error) {
        console.error("Error parsing cart settings:", error);
      }
    } else {
      console.warn(
        "[cart.tsx] No cart settings data found in data-cart-settings attribute"
      );
    }
    createRoot(root).render(<CartIndex cartSettings={cartSettings} />);
  }
});
